import { ExclamationIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { Button } from "../../Components/Button";
import { ModalConfirm } from "../../Components/ModalConfirm";
import {
  clearUpdateNPWPDraft,
  requestCreateNPWPDraft,
  requestUpdateNPWPDraft,
  useAuthState,
  useNPWPDispatch,
  useNPWPState,
} from "../../Context";
import { Alert } from "../../Components/Alert";
import { useRemoteConfig } from "../../Context/firebase/context";

export const MARRIAGE_STATUS = [
  {
    label: "Belum Kawin",
    value: 2,
  },
  {
    label: "Kawin",
    value: 1,
  },
  {
    label: "Cerai Hidup",
    value: 3,
  },
  {
    label: "Cerai Mati",
    value: 4,
  },
];

export const ALL_NPWP_TAX_CATEGORIES = [
  {
    label: "Orang Pribadi",
    value: 1,
  },
  {
    label: "Wanita yang telah hidup berpisah berdasarkan putusan hakim (HB)",
    value: 2,
  },
  {
    label: "Istri dengan perjanjian pemisahan harta dan penghasilan (PH)",
    value: 3,
  },
  {
    label:
      "Istri memilih menjalankan hak dan kewajiban perpajakan terpisan (MT)",
    value: 4,
  },
];

export const NPWPPreregister = () => {
  const { t } = useTranslation();
  const dispatch = useNPWPDispatch();
  const navigate = useNavigate();
  const { user } = useAuthState();
  const { statusNPWPDraft, loading, errorNPWPDraft } = useNPWPState();
  const { npwp_registration: npwpRegistrationConfig } = useRemoteConfig();

  const [modal, setModal] = useState({
    visible: false,
    title: "",
    description: "",
    type: "",
  });
  const [showDraftErrorModal, setshowDraftErrorModal] = useState(false);
  const [modalDraftDescription, setmodalDraftDescription] = useState("");
  const [showMarriageStatus, setshowMarriageStatus] = useState("");
  const [npwpMenuEnabled, setnpwpMenuEnabled] = useState(false);

  const [taxpayerCategory, settaxpayerCategory] = useState("");
  const [nationalityCode, setnationalityCode] = useState("WNI");
  const [status, setstatus] = useState("PUSAT");
  const [gender, setgender] = useState("");
  const [marriageStatus, setmarriageStatus] = useState("");

  useEffect(() => {
    setnpwpMenuEnabled(npwpRegistrationConfig === "enabled");
  }, [npwpRegistrationConfig]);

  useEffect(() => {
    if (marriageStatus.value === 1) {
      setshowMarriageStatus("married");
    } else if (marriageStatus.value === 3) {
      setshowMarriageStatus("divorced");
    } else if (marriageStatus.value === 4) {
      setshowMarriageStatus("who are widowed");
    }
  }, [marriageStatus.value]);

  useEffect(() => {
    if (gender === "0" && marriageStatus.value) {
      settaxpayerCategory(ALL_NPWP_TAX_CATEGORIES[0]);
    } else if (gender === "1" && marriageStatus.value === 2) {
      settaxpayerCategory(ALL_NPWP_TAX_CATEGORIES[0]);
    }
  }, [gender, marriageStatus.value]);

  useEffect(() => {
    if (statusNPWPDraft === "SUCCESS") {
      navigate("/npwp-create");
      clearUpdateNPWPDraft(dispatch);
    }
  }, [statusNPWPDraft, navigate, dispatch]);

  useEffect(() => {
    if (errorNPWPDraft) {
      setshowDraftErrorModal(true);
    }
  }, [errorNPWPDraft]);

  useEffect(() => {
    const currentGender = user.npwpDraft?.gender || 0;
    setgender(currentGender.toString());

    if (user.npwpDraft?.marriageStatus) {
      setmarriageStatus(
        MARRIAGE_STATUS.filter(
          (item) => item.value === user.npwpDraft.marriageStatus
        )
      );
    }

    if (user.npwpDraft?.isMain === false) {
      setstatus("CABANG");
    } else {
      setstatus("PUSAT");
    }

    if (user.npwpDraft?.countryCode) {
      setnationalityCode(user.npwpDraft.countryCode);
    }

    if (user.npwpDraft?.taxCategory) {
      settaxpayerCategory(
        ALL_NPWP_TAX_CATEGORIES.filter(
          (allNPWPTaxCategorie) =>
            allNPWPTaxCategorie.value === user.npwpDraft.taxCategory
        )
      );
    }
  }, [user.npwpDraft]);

  useEffect(() => {
    if (user.registeredNpwp?.id) {
      navigate(`/settings/npwp`);
    }
  }, [user.registeredNpwp?.id, navigate]);

  useEffect(() => {
    let errorMessageDraft = "An error occurred, please try again.";
    if (errorNPWPDraft?.errors) {
      errorMessageDraft = "";
      for (let i = 0; i < errorNPWPDraft.errors.length; i++) {
        const error = errorNPWPDraft.errors[i];
        if (error.message) {
          if (errorMessageDraft !== "") {
            errorMessageDraft += ` ${error.message}`;
          } else {
            errorMessageDraft += error.message;
          }
        }
      }
    }
    setmodalDraftDescription(t(errorMessageDraft));
  }, [errorNPWPDraft, t]);

  const handlePrevious = () => {
    navigate("/npwp-services");
  };

  const handleNext = () => {
    let isMain;
    let countryCode;
    if (user.membership === "PREMIUM") {
      if (status === "PUSAT") {
        isMain = true;
      }
      if (status === "CABANG") {
        isMain = false;
      }
      if (nationalityCode === "WNI") {
        countryCode = "ID";
      }
      if (nationalityCode === "WNA") {
        countryCode = "NONID";
      }
      const npwpDraftData = {
        userID: user.id,
        input: {
          isMain,
          countryCode,
          gender: parseInt(gender),
          marriageStatus: marriageStatus.value,
          taxCategory: taxpayerCategory.value,
        },
      };

      if (!user.npwpDraftID) {
        requestCreateNPWPDraft(dispatch, npwpDraftData);
      } else {
        npwpDraftData.input.id = user.npwpDraftID;
        requestUpdateNPWPDraft(dispatch, npwpDraftData);
      }
    } else {
      setModal({
        visible: true,
        title: t("Premium Feature"),
        description: t("Only premium member can use the create NPWP feature."),
        type: "WARNING",
      });
    }
  };

  const showStatusWarning = status === "CABANG" && nationalityCode !== "WNA";
  const showNationalityCodeWarning = nationalityCode === "WNA";
  const showGenderWarning =
    gender === "1" &&
    ([1, 3, 4].includes(marriageStatus.value) ||
      [2, 3, 4].includes(taxpayerCategory.value)) &&
    status !== "CABANG" &&
    nationalityCode !== "WNA";

  function formSkeleton() {
    return (
      <div className="animate-pulse col-span-12">
        <div className="space-y-6 py-5 lg:px-8 px-3">
          <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const WarningMessage = ({ title, description, linkText, linkUrl }) => (
    <div className="pt-6">
      <div className="p-4 rounded-md bg-yellow-50">
        <div className="flex">
          <div className="flex-shrink-0">
            <ExclamationIcon
              className="h-5 w-5 text-yellow-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3 w-full">
            <h3 className="text-sm font-medium text-yellow-800">{title}</h3>
            <div className="text-sm text-yellow-700">
              <p>
                {description}{" "}
                <a className="text-blue-600" href={linkUrl}>
                  {linkText}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white border border-gray-200 divide-y divide-gray-200 shadow rounded-md sm:rounded-lg ">
      <ModalConfirm
        open={modal.visible}
        setOpen={(open) => {
          setModal((prevModal) => ({
            ...prevModal,
            visible: open,
          }));
        }}
        title={modal.title}
        description={modal.description}
        type={modal.type}
        confirmTitle={t("Subscribe")}
        onConfirm={() => {
          navigate("/subscription");
        }}
      />

      <ModalConfirm
        open={showDraftErrorModal && modalDraftDescription !== ""}
        setOpen={(open) => setshowDraftErrorModal(open)}
        title="Error"
        description={modalDraftDescription}
        type="ALERT"
        onConfirm={() => setshowDraftErrorModal(false)}
      />

      {npwpMenuEnabled ? (
        <div>
          {loading ? (
            formSkeleton()
          ) : (
            <div className="px-6 py-5 sm:p-6">
              <div>
                <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                  {/* Main */}
                  <div>
                    <label
                      htmlFor="main"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t("Is the NPWP for branches?")}
                    </label>
                    <div className="flex flex-col sm:flex-row mt-2 gap-2 pb-3">
                      <div className="flex flex-1 items-center">
                        <input
                          id="cabang"
                          type="radio"
                          className="form-radio h-4 w-4 border-gray-300 text-blue-500 focus:ring-blue-500"
                          name="main"
                          value={"CABANG"}
                          checked={status === "CABANG"}
                          onChange={(e) => setstatus(e.target.value)}
                        />
                        <label
                          htmlFor="cabang"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("Yes")}
                        </label>
                      </div>
                      <div className="flex flex-1 items-center">
                        <input
                          id="pusat"
                          className="form-radio h-4 w-4 border-gray-300 text-blue-500 focus:ring-blue-500"
                          name="main"
                          type="radio"
                          value={"PUSAT"}
                          checked={status === "PUSAT"}
                          onChange={(e) => setstatus(e.target.value)}
                        />
                        <label
                          htmlFor="pusat"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("No")}
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* Gender */}
                  <div>
                    <label
                      htmlFor="gender"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t("Gender")}
                    </label>
                    <div className="flex flex-col sm:flex-row mt-2 gap-2">
                      <div className="flex flex-1 items-center">
                        <input
                          id="male"
                          name="gender"
                          type="radio"
                          className="form-radio h-4 w-4 border-gray-300 text-blue-500 focus:ring-blue-500"
                          value={"0"}
                          checked={gender === "0"}
                          onChange={(e) => setgender(e.target.value)}
                        />
                        <label
                          htmlFor="male"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("Male")}
                        </label>
                      </div>
                      <div className="flex flex-1 items-center">
                        <input
                          id="female"
                          name="gender"
                          type="radio"
                          className="form-radio h-4 w-4 border-gray-300 text-blue-500 focus:ring-blue-500"
                          value={"1"}
                          checked={gender === "1"}
                          onChange={(e) => setgender(e.target.value)}
                        />
                        <label
                          htmlFor="female"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("Female")}
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* Marriage Status */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      {t("Marriage Status")}
                    </label>
                    <ReactSelect
                      className="mt-1 text-sm"
                      classNamePrefix="select2-selection"
                      name="marriageStatus"
                      value={marriageStatus}
                      onChange={setmarriageStatus}
                      options={MARRIAGE_STATUS}
                      placeholder={t("Select Marriage Status")}
                    />
                  </div>
                  {/* Nationality */}
                  <div>
                    <label
                      htmlFor="nationalityCode"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t("Nationality")}
                    </label>
                    <select
                      className="mt-1 block w-full text-sm rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-blue-600 focus:outline-none focus:ring-blue-600"
                      name="nationalityCode"
                      value={nationalityCode}
                      onChange={(e) => setnationalityCode(e.target.value)}
                    >
                      <option value="WNI">{t("WNI")}</option>
                      <option value="WNA">{t("WNA (Foreigner)")}</option>
                    </select>
                  </div>
                  {/* Taxpayer Category */}
                  <div>
                    <label
                      htmlFor="taxpayerCategory"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t("Taxpayer Category")}
                    </label>
                    <ReactSelect
                      name="taxpayerCategory"
                      className="mt-1 text-sm"
                      classNamePrefix="select"
                      options={ALL_NPWP_TAX_CATEGORIES}
                      value={taxpayerCategory}
                      placeholder={t("Select Taxpayer Category")}
                      onChange={settaxpayerCategory}
                      isDisabled={gender && marriageStatus}
                    />
                  </div>
                </div>
              </div>
              {showStatusWarning && (
                <WarningMessage
                  title={t("Not supported yet")}
                  description={t(
                    "Branch NPWP registration is not yet supported."
                  )}
                  linkText={t("Use DJP Online version")}
                  linkUrl="https://ereg.pajak.go.id/login"
                />
              )}

              {showNationalityCodeWarning && (
                <WarningMessage
                  title={t("Not supported yet")}
                  description={t(
                    "The registration of NPWP for foreign nationals is not yet supported."
                  )}
                  linkText={t("Use DJP Online version")}
                  linkUrl="https://ereg.pajak.go.id/login"
                />
              )}

              {showGenderWarning && (
                <WarningMessage
                  title={t("Not supported yet")}
                  description={t(
                    `Registration of NPWP for ${showMarriageStatus} women category is not yet supported.`
                  )}
                  linkText={t("Use DJP Online version")}
                  linkUrl="https://ereg.pajak.go.id/login"
                />
              )}
            </div>
          )}
          <div className="px-6 py-5 flex items-center justify-between flex-wrap border-t border-gray-200 gap-4">
            <Button
              type="button"
              onClick={() => handlePrevious()}
              title="Previous"
              outline
              disabled={loading}
            />
            <Button
              title="Next"
              onClick={() => handleNext()}
              disabled={
                loading ||
                (gender === "1" && [1, 3, 4].includes(marriageStatus.value)) ||
                !taxpayerCategory ||
                !nationalityCode ||
                !marriageStatus ||
                !status ||
                !gender ||
                status === "CABANG" ||
                nationalityCode === "WNA"
              }
              loading={loading}
            />
          </div>
        </div>
      ) : (
        <div className="px-4 py-6 sm:px-6">
          <Alert
            title="Sorry"
            type="warning"
            message="The service is currently unavailable."
          />
        </div>
      )}
    </div>
  );
};
